import axios from "axios"

async function postCustomerBindToWorkspaceApi(data: {customer_id: string, workspace_uuid: string}){
    return axios({
        method: "POST",
        url: `/api/v1/customer-workspace`,
        data
    })
}

async function getWorkspaceByCustomerIdApi(customerId: string){
    return axios({
        method: "GET",
        url: `/api/v1/customer-workspace/${customerId}/workspace-id`
    })
}

async function getCustomerByWorkspaceIdApi(customerId: string){
    return axios({
        method: "GET",
        url: `/api/v1/customer-workspace/${customerId}/workspace-id`
    })
}



export {
    postCustomerBindToWorkspaceApi,
    getWorkspaceByCustomerIdApi,
    getCustomerByWorkspaceIdApi
}
